import { CaseDataManagerObjects } from 'dashboard/models/case';
import { FieldsMap } from 'lib/fields';

export const getCasesData = (
  caseFields: FieldsMap,
  caseDataManager?: Partial<Record<CaseDataManagerObjects, Record<string, any>>>,
) => {
  const caseFieldsData = Object.keys(caseFields).reduce(
    (attrs, key) => ({
      ...attrs,
      [key]: caseFields[key]?.value,
    }),
    {},
  );

  // [chris] TODO: During migration away from direct field access, we'll have caseFields live at the top level of data along with the CaseDataManager.
  // This is because the CaseDataManagerSchemaSelect component does not support direct field name access.
  return {
    ...caseFieldsData,
    ...caseDataManager,
  };
};
